import i18n from 'i18n';
import { COMMON_GRID_COLUMN_FIELD_NAMES } from '../../shared/commonGrid/grid-enums';
import { stringArrayComparator } from '../../shared/commonGrid/grid-util';

export default [
  {
    headerName: '',
    field: COMMON_GRID_COLUMN_FIELD_NAMES.Action,
    cellRenderer: 'actionMenuCellRenderer',
  },
  {
    headerName: i18n.t('team.grid.name'),
    field: 'name',
    filter: 'agTextColumnFilter',
    sortable: true,
    resizable: true,
    tooltipField: 'name',
  },
  {
    headerName: i18n.t('team.grid.cspid'),
    field: 'cspid',
    filter: 'agTextColumnFilter',
    sortable: true,
    resizable: true,
    tooltipField: 'cspid',
  },
  {
    headerName: i18n.t('team.grid.description'),
    field: 'description',
    filter: 'agTextColumnFilter',
    sortable: true,
    resizable: true,
    tooltipField: 'description',
  },
  {
    headerName: i18n.t('team.grid.numberMembers'),
    field: 'num_of_members',
    filter: 'agNumberColumnFilter',
    resizable: true,
    sortable: true,
    tooltipField: 'num_of_members',
  },
  {
    headerName: i18n.t('team.grid.members'),
    field: 'members',
    sortable: true,
    resizable: true,
    filter: 'agTextColumnFilter',
    filterParams: { textCustomComparator: stringArrayComparator },
    tooltipField: 'members',
  },
];
